import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function VideoGeneration() {
  const [children, setChildren] = useState([])
  const [selectedChild, setSelectedChild] = useState(null)
  const [videoType, setVideoType] = useState('activity_review')
  const [tasks, setTasks] = useState([])
  const [loading, setLoading] = useState(false)
  const [generating, setGenerating] = useState(false)

  useEffect(() => {
    loadChildren()
    loadTasks()
    const interval = setInterval(loadTasks, 3000)
    return () => clearInterval(interval)
  }, [])

  const loadChildren = () => { fetch(`${API}/children?limit=50`).then(r => r.json()).then(d => { if (d.success) setChildren(d.data || []) }) }
  const loadTasks = () => { fetch(`${API}/video-task/tasks?limit=20`).then(r => r.json()).then(d => { if (d.success) setTasks(d.data || []) }) }

  const handleGenerate = async () => {
    if (!selectedChild) { alert('请先选择孩子'); return }
    setGenerating(true)
    try {
      const res = await fetch(`${API}/video-task/generate`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ child_id: selectedChild.id, video_type: videoType, options: { photos: selectedChild.avatar ? [selectedChild.avatar] : [], activity_name: '精彩活动回顾' } }) })
      const data = await res.json()
      if (data.success) { alert('视频生成任务已创建！'); loadTasks() } else alert('创建失败: ' + data.error)
    } catch (err) { alert('网络错误') } finally { setGenerating(false) }
  }

  const videoTypes = [
    { key: 'activity_review', name: '活动回顾视频', desc: '展示活动精彩照片' },
    { key: 'achievement', name: '成就展示视频', desc: '展示证书和成就' },
    { key: 'annual_summary', name: '年度总结视频', desc: '回顾全年成长' },
    { key: 'course_completion', name: '课程结业视频', desc: '记录课程学习历程' },
    { key: 'birthday', name: '生日祝福视频', desc: '定制生日祝福' },
  ]

  const getStatusBadge = (status) => {
    const badges = { pending: { bg: '#f5f5f5', color: '#999', text: '等待' }, queued: { bg: '#e6f7ff', color: '#1890ff', text: '排队中' }, processing: { bg: '#fff7e6', color: '#fa8c16', text: '生成中' }, completed: { bg: '#f6ffed', color: '#52c41a', text: '已完成' }, failed: { bg: '#fff1f0', color: '#f5222d', text: '失败' } }
    const b = badges[status] || badges.pending
    return <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 12, background: b.bg, color: b.color }}>{b.text}</span>
  }

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>🎬 视频生成系统</h2>
      <p style={{ color: '#666', marginBottom: 20 }}>Phase 1: 使用 FFmpeg 生成活动回顾、成就展示视频（成长视频产品可收费 ¥39-199）</p>

      <div style={{ background: '#fff', borderRadius: 12, padding: 24, marginBottom: 20 }}>
        <h3 style={{ fontSize: 14, marginBottom: 16 }}>创建视频生成任务</h3>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 8, fontSize: 13, color: '#666' }}>选择孩子</label>
          <select onChange={e => { const c = children.find(x => x.id === e.target.value); setSelectedChild(c) }} style={{ padding: '10px', border: '1px solid #d9d9d9', borderRadius: 6, width: 300, fontSize: 14 }}>
            <option value="">请选择孩子</option>
            {children.map(c => <option key={c.id} value={c.id}>{c.name} - {c.institution_name || c.school || '未分配'}</option>)}
          </select>
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 8, fontSize: 13, color: '#666' }}>视频类型</label>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 10 }}>
            {videoTypes.map(vt => (
              <div key={vt.key} onClick={() => setVideoType(vt.key)} style={{ padding: 12, borderRadius: 8, cursor: 'pointer', border: videoType === vt.key ? '2px solid #1890ff' : '2px solid #f0f0f0', background: videoType === vt.key ? '#e6f7ff' : '#fafafa' }}>
                <div style={{ fontWeight: 500, fontSize: 13 }}>{vt.name}</div>
                <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>{vt.desc}</div>
              </div>
            ))}
          </div>
        </div>
        <button onClick={handleGenerate} disabled={generating || !selectedChild} style={{ padding: '12px 24px', background: generating || !selectedChild ? '#d9d9d9' : '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: generating || !selectedChild ? 'not-allowed' : 'pointer', fontSize: 14 }}>
          {generating ? '生成中...' : '🎬 开始生成视频'}
        </button>
      </div>

      <div style={{ background: '#fff', borderRadius: 12, padding: 24 }}>
        <h3 style={{ fontSize: 14, marginBottom: 16 }}>视频生成任务</h3>
        {tasks.length === 0 ? <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>暂无生成任务</div> : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr style={{ background: '#fafafa' }}>{['任务ID', '孩子', '视频类型', '状态', '进度', '创建时间'].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
            <tbody>
              {tasks.map(task => (
                <tr key={task.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ ...td, fontFamily: 'monospace', fontSize: 12 }}>{task.id}</td>
                  <td style={td}>{children.find(c => c.id === task.child_id)?.name || task.child_id}</td>
                  <td style={td}>{videoTypes.find(v => v.key === task.video_type)?.name || task.video_type}</td>
                  <td style={td}>{getStatusBadge(task.status)}</td>
                  <td style={td}><div style={{ display: 'flex', alignItems: 'center', gap: 8 }}><div style={{ width: 80, height: 6, background: '#f0f0f0', borderRadius: 3 }}><div style={{ width: `${task.progress || 0}%`, height: '100%', background: '#1890ff', borderRadius: 3 }} /></div><span style={{ fontSize: 12, color: '#999' }}>{task.progress || 0}%</span></div></td>
                  <td style={{ ...td, fontSize: 12, color: '#999' }}>{task.created_at?.slice(0, 16)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div style={{ marginTop: 20, padding: 16, background: '#f6ffed', borderRadius: 8 }}>
        <h4 style={{ fontSize: 13, color: '#52c41a', marginBottom: 8 }}>💡 Phase 1 技术说明</h4>
        <div style={{ fontSize: 13, color: '#666', lineHeight: 1.8 }}>
          <div>✅ 视频合成：FFmpeg（开源免费）</div>
          <div>✅ 照片处理：自动缩放、裁剪、加字幕</div>
          <div>✅ 视频模板：10个预设模板（16:9 / 9:16）</div>
          <div>✅ 输出格式：MP4，1280x720 / 720x1280</div>
        </div>
      </div>
    </div>
  )
}

const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
